import OrganizationOnboardingConfirmation from 'features/organizations/components/organisms/OrganizationOnboardingConfirmation/OrganizationOnboardingConfirmation';

export default OrganizationOnboardingConfirmation;
